/**
 * UserDetailContainer
 * --
 */
import React, { useState, useEffect } from 'react';
import UserDetailPresenter from './UserDetailPresenter';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useGetUsers, useUpdateUser } from 'hooks/UserHooks';
import { useGetGrades } from 'hooks/GradeHooks';
import useUpdateQuery from 'utils/useUpdateQuery';
import MessageAlert from 'utils';
import { useUpdateCouponUser } from 'hooks/CouponUserHooks';
import Formatter from 'utils/Formatter';
import { UserApi, JmPayApi } from 'api';

/**----------------------------------------
 * [Component] 관리자 > 유저상세
 * ----------------------------------------
 */
const UserDetailContainer = ({ defaultUserId, permission, manageType }) => {
  /* ===== ROUTE ===== */
  /* ===== STATE ===== */
  const [currentUserId, _setCurrentUserId] = useState(defaultUserId ?? null);
  const [userData, setUserData] = useState(null);
  const [jmpayData, setJmpayData] = useState([]);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   *
   * --
   */
  const getUser = async () => {
    try {
      const { status, message, data } = await UserApi.getUser(currentUserId);
      if (status !== 200) throw { message };
      setUserData(data);
    } catch (e) {
      MessageAlert.error(e.message);
    }
  };

  /**
   * 데이터 조회
   * --
   */
  const getJmPayList = async () => {
    try {
      const { status, message, data } = await JmPayApi.getJmPays({
        user_id: currentUserId,
      });
      if (status !== 200) throw { message };
      setJmpayData(data);
    } catch (e) {
      MessageAlert.error(e.message);
    }
  };
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  useEffect(() => {
    currentUserId && getUser();
    currentUserId && manageType === 'JM_PAY' && getJmPayList();
  }, [currentUserId]);
  /* ===== RENDER ===== */
  return (
    <>
      <UserDetailPresenter
        {...{
          currentUserId,
          userData,
          manageType,
          jmpayData,
        }}
      />
    </>
  );
};

/*  */
UserDetailContainer.defaultProps = {
  defaultUserId: null,
  permission: null,
  manageType: 'DEFAULT',
};
export default UserDetailContainer;
